export default "__VITE_ASSET__121ef2c6__"